import { createAction, props } from '@ngrx/store';
import { FacilityTypeDto } from 'src/app/compliance/api/models/facility-type-dto.model';
import { LocumsContractTypeSettingsDto } from 'src/app/compliance/api/models/locums-contract-type-settings-dto.model';
import { ManualReviewCandidateTypeDto } from 'src/app/compliance/api/models/manual-review-candidate-type-dto.model';
import { WorkTypeSettingsDto } from 'src/app/compliance/api/models/work-type-settings-dto.model';
import { CategoryLineOfBusiness } from 'src/app/compliance/enums/category-line-of-business.enum';
import { DocAdminPermissions } from 'src/app/compliance/models/doc-admin-permissions.model';
import { DocumentTypeCategory } from 'src/app/compliance/models/document-type-category.model';
import { DocumentTypesCreate } from 'src/app/compliance/models/document-types-create.model';
import { DocumentTypesUpdate } from 'src/app/compliance/models/document-types-update.model';
import { DocmentTypeFile, DocumentTypes } from 'src/app/compliance/models/document-types.model';
import { KeyValue } from 'src/app/shared/models/key-value.model';

export const getPermissions = createAction('[Doc Admin Details Component] Get Permissions');

export const getPermissionsSuccess = createAction(
    '[Doc Admin API] Get Permissions Success',
    props<{ permissions: DocAdminPermissions }>()
);

export const getPermissionsFailure = createAction('[Doc Admin API] Get Permissions Failure', props<{ error: any }>());

export const getInitFacilityLookup = createAction(
    '[Doc Admin Details Component] Get Init Facility Lookup',
    props<{ id: number; lob: number }>()
);

export const getInitFacilityLookupSuccess = createAction(
    '[Doc Admin API] Get Init Facility Lookup Success',
    props<{ facility: KeyValue<number, string> }>()
);

export const getInitFacilityLookupFailure = createAction(
    '[Doc Admin API] Get Init Facility Lookup Failure',
    props<{ error: any }>()
);

export const getInitStateLookup = createAction(
    '[Doc Admin Details Component] Get Init State Lookup',
    props<{ id: number }>()
);

export const getInitStateLookupSuccess = createAction(
    '[Doc Admin API] Get Init State Lookup Success',
    props<{ state: KeyValue<number, string> }>()
);

export const getInitStateLookupFailure = createAction(
    '[Doc Admin API] Get Init State Lookup Failure',
    props<{ error: any }>()
);

export const getFacilityLookups = createAction(
    '[Doc Admin Details Component] Get Facility Lookups',
    props<{ name: string; lob: number }>()
);

export const getFacilityLookupsSuccess = createAction(
    '[Doc Admin API] Get Facility Lookups Success',
    props<{ facilities: KeyValue<number, string>[] }>()
);

export const getFacilityLookupsFailure = createAction(
    '[Doc Admin API] Get Facility Lookups Failure',
    props<{ error: any }>()
);

export const setCurrentDocumentLevel = createAction(
    '[Doc Admin Details Component] Set Current Document Level',
    props<{ documentTypeLevel: number }>()
);

export const clearCurrentDocumentLevel = createAction('[Doc Admin Details Component] Clear Current Document Level');

export const setCurrentDocumentId = createAction(
    '[Doc Admin Details Component] Set Current Document Id',
    props<{ documentId: number }>()
);

export const clearCurrentDocumentId = createAction('[Doc Admin Details Component] Clear Current Document Id');

export const clearFacilityLookups = createAction('[Doc Admin Details Component] Clear Facility Lookups');

export const clearAssociationLookups = createAction('[Doc Admin Details Component] Clear Association Lookups');

export const clearInitAssociationLookups = createAction('[Doc Admin Details Component] Clear Init Association Lookups');

export const clearInitFacilityLookups = createAction('[Doc Admin Details Component] Clear Init Facility Lookups');

export const clearDocumentTypeCategories = createAction('[Doc Admin Details Component] Clear Document Type Categories');

export const getInitAssociationLookup = createAction(
    '[Doc Admin Details Component] Get Init Association Lookup',
    props<{ id: number }>()
);

export const getInitAssociationLookupSoccess = createAction(
    '[Doc Admin API] Get Init Association Lookup Success',
    props<{ association: KeyValue<number, string> }>()
);

export const getInitAssociationLookupFailure = createAction(
    '[Doc Admin API] Get Init Association Lookup Failure',
    props<{ error: any }>()
);

export const getAssociationLookups = createAction(
    '[Doc Admin Details Component] Get Association Lookups',
    props<{ name: string }>()
);

export const getAssociationLookupsSuccess = createAction(
    '[Doc Admin API] Get Association Lookups Success',
    props<{ associations: KeyValue<number, string>[] }>()
);

export const getAssociationLookupsFailure = createAction(
    '[Doc Admin API] Get Association Lookups Failure',
    props<{ error: any }>()
);

export const getSpecialtyLookups = createAction(
    '[Doc Admin Details Component] Get Specialty Lookups',
    props<{ getLocums: boolean }>()
);

export const getSpecialtyLookupsSuccess = createAction(
    '[Doc Admin API] Get Specialty Lookups Success',
    props<{ specialties: KeyValue<number, string>[] }>()
);

export const getSpecialtyLookupsFailure = createAction(
    '[Doc Admin API] Get Specialty Lookups Failure',
    props<{ error: any }>()
);

export const getStateLookups = createAction('[Doc Admin Details Component] Get State Lookups');

export const getStateLookupsSuccess = createAction(
    '[Doc Admin API] Get State Lookups Success',
    props<{ states: KeyValue<number, string>[] }>()
);

export const getStateLookupsFailure = createAction(
    '[Doc Admin API] Get State Lookups Failure',
    props<{ error: any }>()
);

export const getFacilityTypeLookups = createAction('[Doc Admin Details Component] Get FacilityType Lookups');

export const getFacilityTypeLookupsSuccess = createAction(
    '[Doc Admin API] Get FacilityType Lookups Success',
    props<{ facilityTypes: FacilityTypeDto[] }>()
);

export const getFacilityTypeLookupsFailure = createAction(
    '[Doc Admin API] Get FacilityType Lookups Failure',
    props<{ error: any }>()
);

export const getManualReviewCandidateTypeSettingLookups = createAction(
    '[Doc Admin Details Component] Get Manual Qualification Review Lookups'
);

export const getManualReviewCandidateTypeSettingLookupsSuccess = createAction(
    '[Doc Admin API] Get Manual Qualification Review Lookups Success',
    props<{ manualReviewTypes: ManualReviewCandidateTypeDto[] }>()
);

export const getManualReviewCandidateTypeSettingLookupsFailure = createAction(
    '[Doc Admin API] Get Manual Qualification Review Lookups Failure',
    props<{ error: any }>()
);

export const getWorkTypeSettingsLookups = createAction('[Doc Admin Details Component] Get WorkTypeSetting Lookups');

export const getWorkTypeSettingLookupsSuccess = createAction(
    '[Doc Admin API] Get WorkTypeSetting Lookups Success',
    props<{ workTypeSettings: WorkTypeSettingsDto[] }>()
);

export const getWorkTypeSettingLookupsFailure = createAction(
    '[Doc Admin API] Get WorkTypeSetting Lookups Failure',
    props<{ error: any }>()
);

export const getLocumsContractTypeSettingsLookups = createAction(
    '[Doc Admin Details Component] Get LocumsContractTypeSetting Lookups'
);

export const getLocumsContractTypeSettingLookupsSuccess = createAction(
    '[Doc Admin API] Get LocumsContractTypeSetting Lookups Success',
    props<{ locumsContractTypeSettings: LocumsContractTypeSettingsDto[] }>()
);

export const getLocumsContractTypeSettingLookupsFailure = createAction(
    '[Doc Admin API] Get LocumsContractTypeSetting Lookups Failure',
    props<{ error: any }>()
);

export const getLinesOfBusinessLookups = createAction('[Doc Admin Details Component] Get Lines of Business Lookups');

export const getLinesOfBusinessLookupsSuccess = createAction(
    '[Doc Admin API] Get Lines of Business Lookups Success',
    props<{ linesOfBusiness: KeyValue<number, string>[] }>()
);

export const getLinesOfBusinessLookupsFailure = createAction(
    '[Doc Admin API] Get Lines of Business Lookups Failure',
    props<{ error: any }>()
);

export const getCandidateTaskTypes = createAction('[Doc Admin Details Component] Get Candidate Task Types');

export const getCandidateTaskTypesSuccess = createAction(
    '[Doc Admin API] Get Candidate Task Types Success',
    props<{ candidateTaskTypes: KeyValue<number, string>[] }>()
);

export const getCandidateTaskTypesFailure = createAction(
    '[Doc Admin API] Get Candidate Task Types Failure',
    props<{ error: any }>()
);

export const getPartnerNetworkTaskTypes = createAction('[Doc Admin Details Component] Get PartnerNetwork Task Types');

export const getPartnerNetworkTaskTypesSuccess = createAction(
    '[Doc Admin API] Get PartnerNetwork Task Types Success',
    props<{ partnerNetworkTaskTypes: KeyValue<number, string>[] }>()
);

export const getPartnerNetworkTaskTypesFailure = createAction(
    '[Doc Admin API] Get PartnerNetwork Task Types Failure',
    props<{ error: any }>()
);

export const getDocumentTypeCategories = createAction(
    '[Doc Admin Details Component] Get Document Type Categories',
    props<{ catLob: CategoryLineOfBusiness }>()
);

export const getDocumentTypeCategoriesList = createAction(
    '[Doc Admin Details Component] Get Document Type Categories List'
);

export const getDocumentTypeCategoriesSuccess = createAction(
    '[Doc Admin API] Get Document Type Categories Success',
    props<{ documentTypeCatories: DocumentTypeCategory[] }>()
);

export const getDocumentTypeCategoriesListSuccess = createAction(
    '[Doc Admin API] Get Document Type Categories List Success',
    props<{ documentTypeCategoriesList: string[] }>()
);

export const getDocumentTypeCategoriesFailure = createAction(
    '[Doc Admin API] Get Document Type Categories Failure',
    props<{ error: any }>()
);

export const getDocumentTypeCategoriesListFailure = createAction(
    '[Doc Admin API] Get Document Type Categories List Failure',
    props<{ error: any }>()
);

export const uploadDocumentFile = createAction(
    '[Doc Admin Details Component] Upload Document File',
    props<{ documentFile: DocmentTypeFile; documentId: number }>()
);

export const uploadDocumentFileSuccess = createAction(
    '[Doc Admin Details Component] Upload Document File Success',
    props<{ document: DocumentTypes }>()
);

export const uploadDocumentFileFailure = createAction(
    '[Doc Admin Details Component] Upload Document File Failure',
    props<{ error: any }>()
);

export const uploadCandidateReviewDocumentFile = createAction(
    '[Doc Admin Details Component] Upload Candidate Review Document File',
    props<{ candidateReviewDocumentFile: DocmentTypeFile; documentId: number }>()
);

export const uploadCandidateReviewDocumentFileSuccess = createAction(
    '[Doc Admin Details Component] Upload Candidate Review Document File Success',
    props<{ document: DocumentTypes }>()
);

export const uploadCandidateReviewDocumentFileFailure = createAction(
    '[Doc Admin Details Component] Upload Candidate Review Document File Failure',
    props<{ error: any }>()
);

export const uploadDocument = createAction(
    '[Doc Admin Details Component] Upload Document',
    props<{
        document: DocumentTypesCreate;
        documentFile: DocmentTypeFile;
        candidateReviewDocumentFile: DocmentTypeFile;
    }>()
);

export const uploadDocumentSuccess = createAction(
    '[Doc Admin API] Upload Document Success',
    props<{ document: DocumentTypes }>()
);

export const uploadDocumentFailure = createAction('[Doc Admin API] Upload Document Failure', props<{ error: any }>());

export const updateDocument = createAction(
    '[Doc Admin Details Component] Update Document',
    props<{
        document: DocumentTypesUpdate;
        documentFile: DocmentTypeFile;
        candidateReviewDocumentFile?: DocmentTypeFile;
    }>()
);

export const updateDocumentSuccess = createAction(
    '[Doc Admin API] Update Document Success',
    props<{ document: DocumentTypes }>()
);

export const updateDocumentFailure = createAction('[Doc Admin API] Update Documents Failure', props<{ error: any }>());

export const disableDocument = createAction(
    '[Doc Admin Details Component] Disable Document',
    props<{
        document: DocumentTypesUpdate;
        documentFile: DocmentTypeFile;
        candidateReviewDocumentFile?: DocmentTypeFile;
    }>()
);

export const disableDocumentSuccess = createAction(
    '[Doc Admin Details Component] Disable Document Success',
    props<{ document: DocumentTypes }>()
);

export const disableDocumentFailure = createAction(
    '[Doc Admin API] Disable Documents Failure',
    props<{ error: any }>()
);

export const enableDocument = createAction(
    '[Doc Admin Details Component] Enable Document',
    props<{
        document: DocumentTypesUpdate;
        documentFile: DocmentTypeFile;
        candidateReviewDocumentFile?: DocmentTypeFile;
    }>()
);

export const enableDocumentSuccess = createAction(
    '[Doc Admin Details Component] Enable Document Success',
    props<{ document: DocumentTypes }>()
);

export const enableDocumentFailure = createAction('[Doc Admin API] Enable Documents Failure', props<{ error: any }>());

export const getDocument = createAction('[Doc Admin Details Component] Get Document', props<{ documentId: number }>());

export const getDocumentSuccess = createAction(
    '[Doc Admin API] Get Document Success',
    props<{ document: DocumentTypes }>()
);

export const getDocumentFailure = createAction('[Doc Admin API] Get Document Failure', props<{ error: any }>());

export const initializeDocument = createAction('[Doc Admin Details Component] Initialize Document');

export const initializeDocumentSuccess = createAction(
    '[Doc Admin API] Initialize Document Success',
    props<{ document: DocumentTypes }>()
);

export const initializeDocumentFailure = createAction(
    '[Doc Admin API] Initialize Document Failure',
    props<{ error: any }>()
);

export const createNewDocument = createAction(
    '[Doc Admin Details Component] Create New Document',
    props<{ documentId: number; pages: number[] }>()
);

export const createNewDocumentSuccess = createAction(
    '[Doc Admin API] Create New Document Success',
    props<{ document: DocumentTypes }>()
);

export const createNewDocumentFailure = createAction(
    '[Doc Admin API] Create New Document Failure',
    props<{ error: any }>()
);

export const removeRequirement = createAction(
    '[Doc Admin Details Component] Remove Requirement',
    props<{ documentId: number }>()
);

export const removeRequirementSuccess = createAction(
    '[Doc Admin API] Remove Requirement Success',
    props<{ document: DocumentTypes }>()
);

export const removeRequirementFailure = createAction(
    '[Doc Admin API] Remove Requirement Failure',
    props<{ error: any }>()
);

export const getRequirementLevelLookups = createAction('[Doc Admin Details Component] Get Requirement Level Lookups');

export const getRequirementLevelLookupsSuccess = createAction(
    '[Doc Admin API] Get Requirement Level Lookups Success',
    props<{ requirementLevels: KeyValue<number, string>[] }>()
);

export const getRequirementLevelLookupsFailure = createAction(
    '[Doc Admin API] Get Requirement Level Lookups Failure',
    props<{ error: any }>()
);

export const clearRequirementLevelLookups = createAction(
    '[Doc Admin Details Component] Clear Requirement Level Lookups'
);

export const resetCurrentDocument = createAction('[Doc Admin Details Component] Current Document Reset');
